import React, {useState} from 'react';
import './App.scss';
import {AppShell, Group, Header, Navbar, useMantineColorScheme} from "@mantine/core";
import {Outlet} from "react-router-dom";
import {MainLinks} from "../components/common/Sidebar.links/Sidebar.links";
import UserButton from "../components/common/User.button/User.button";
import AppLogo from "../assets/logo.png";

function Logo () {
    return <img alt="logo" src={AppLogo} height="50%"/>;
}

function App() {
    const [opened] = useState(false);

    return (
            <AppShell
                padding="md"
                fixed
                navbar={
                    <Navbar p="md" hiddenBreakpoint="sm" hidden={!opened} width={{sm: 200, lg: 300}}>
                        <Navbar.Section grow mt="xs">
                            <MainLinks/>
                        </Navbar.Section>
                    </Navbar>
                }
                header={
                    <Header height={60}>
                        <Group sx={{height: '100%'}} px={20} position="apart">
                            <Logo/>
                            <UserButton/>
                        </Group>
                    </Header>
                }
                styles={(theme) => ({
                    main: {
                        backgroundColor:
                            theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0],
                    },
                })}
            >
                <Outlet/>
            </AppShell>
    );
}

export default App;
